// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"312":"CallupHead","421":"PageBottomBrand","638":"CallupVideoAppHead","761":"QQShare","864":"SimpleGuideLayer"}[chunkId] || chunkId) + "." + {"312":"1fc1afe083","421":"325d479e14","633":"78cc024b76","638":"e216bc6df9","761":"31624b2c7b","864":"ce21364634"}[chunkId] + ".js";
};